import { Injectable } from '@angular/core';
import * as global_var from '../global.variable';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MfaChallengeService {
    constructor(private http: HttpClient, private router: Router) { }

    clearSession(data: any) {
        return this.http.post(global_var.apiUrl + 'logoutsession', data
        ).pipe(
            map((res: any) => {
                return res;
            })
        );
    }

    challengeCode(data: any) {
        return this.http.post(global_var.apiUrl + 'verifyMfaCode', data
        ).pipe(
            map((res: any) => {
                return res;
            })
        );
    }

    resendCode({isMFAChallenge = true}) {
        return this.http.post(global_var.apiUrl + 'resendMfaCode', { isMFAChallenge }
        ).pipe(
            map((res: any) => {
                return res;
            })
        );
    }
}